/* eslint-disable no-useless-concat */
/* eslint-disable no-restricted-globals */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';
import { getSection, getMarketSection } from '~helpers/getters';
import Main from '~molecules/main';
import Footer from '../../../../components/molecules/footer';
import Header from '~molecules/header';
import Nav from '~organisms/navigation';
import FloatingArea from '~molecules/floating-area';
import { pageTypes } from '~constants/site-settings/navigation';
import { setCookie, getCookie } from '~helpers/cookies';
import { isSearchPath } from '~helpers/isSearchPath';

function Body({ pageContext, serverData, showFloatingArea = false }) {
  const getBodySection = (name) => getSection(name, pageContext);
  const { template } = pageContext.page;
  const is404 = pageContext?.page?.path?.includes('404');
  const navigation = getMarketSection(
    pageTypes[template]?.section || pageTypes.default.section,
    pageContext
  );
  const main = getBodySection('main');

  const footer = pageTypes[template]?.disableFooter
    ? null
    : getMarketSection('footer', pageContext);

  useEffect(() => {
    if (!getCookie('affUUID')) {
      setCookie('affUUID', uuidv4());
    }
  }, []);

  const customComponent = pageTypes[template]?.customComponent ?? pageTypes.default.customComponent;
  const marketDropdown = pageTypes[template]?.marketDropdown ?? pageTypes.default.marketDropdown;
  const menu = pageTypes[template]?.navMenu ?? pageTypes.default.navMenu;
  const disableSearch = pageTypes[template]?.disableSearch ?? pageTypes.default.disableSearch;
  const isSearch = isSearchPath(pageContext.allMarkets, pageContext.page.path);
  const customPageColor = pageContext.page?.extra_fields?.header_background_color;

  return (
    <>
      <Nav
        template={template}
        pageContext={pageContext}
        section={navigation}
        orientation="horizontal"
        mobileAnimation="collapseFull"
        stopScrollOnOpen
        canOpenAllSubMenus
        disableSearch={disableSearch}
        hasCustomComponent={customComponent}
        hasMarketDropdown={marketDropdown}
        menu={menu}
      />
      {!is404 && !isSearch && <Header serverData={serverData} section={pageContext} />}
      <Main serverData={serverData} section={main} pageContext={pageContext} />
      <Footer
        page={pageContext.page}
        footerMenu="footer_links"
        footerTopCustom={null}
        footerBottomCustom={null}
        footerLogos="footer_logos"
        template={template}
        section={footer}
        customBGColor={customPageColor}
      />
      {showFloatingArea && <FloatingArea pageContext={pageContext} template={template} />}
    </>
  );
}

Body.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  serverData: PropTypes.shape({}),
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      template: PropTypes.string,
      extra_fields: PropTypes.shape({
        header_background_color: PropTypes.string,
      }),
    }),
    allMarkets: PropTypes.shape({}),
  }).isRequired,
  showFloatingArea: PropTypes.bool,
};

export default Body;
